<template>
	<div id="choix-titre">
		<Breadcrumbs/>	

		<h1 class="title has-text-white">
			Choix du magazine
		</h1>
		<h2 class="subtitle has-text-white">
			<p>Voici la liste de nos magazines. Choisissez celui qui vous intéresse.</p>
		</h2>
		<div class="columns" v-for="supports in supportGrouped">
			<div class="column is-one-third" v-for="support in supports">
				<div class="card case-titre" :style="{'--color-svg-hover':support.couleur_dominante}">
					<router-link :to="{name:'Titre',params : {support : support.slug}}" v-if="support" class="card-image">
						<figure v-html="support.logoSvgSupport">
						</figure>
					</router-link>	
				</div>
			</div>
		</div>			

	</div>
</template>
<script>
	export default {
		name : 'ChoixTitre',
		metaInfo: {
			title:'Choix du titre'
		}
	}
</script>
<style lang="scss">
.case-titre {
	transition: background .3s ease;
	&:hover {
		background-color: var(--color-hover);
	}
	figure {
		width: 100%;
		padding-bottom: 100%;
		height: 0;
		svg  {
			position: absolute;
			top:2em;
			left:2em;
			width: calc(100% - 4em);
			height: calc(100% - 4em);
		}
	}
}	
</style>